import { createSelector } from 'reselect'
import { PeopleInvitedToOrgState } from 'src/app/PeopleInvitedToOrg/redux/peopleInvitedToOrg.reducer'
import { RootState } from 'src/redux/createRootReducer'
import { selectInvitedToOrgListModelsFromState } from 'src/redux/selectors/data/invitedToOrg.selectors'

export const selectPeopleInvitedToOrg = (
  state: RootState,
): PeopleInvitedToOrgState => state.app.people.peopleInvitedToOrg

export const selectPeopleInvitedToOrgLoadingFromState = (
  state: RootState,
): boolean => state.app.people.peopleInvitedToOrg.loading

export const selectNumberOfInvitedToOrgFromState = (state: RootState): number =>
  state.app.people.peopleInvitedToOrg.totalItems || 0

const selectUniquePeopleContactIds = createSelector(
  [selectPeopleInvitedToOrg],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)

export const selectUniquePeopleListModels = createSelector(
  [selectUniquePeopleContactIds, selectInvitedToOrgListModelsFromState],
  (ids, invited) => {
    return ids.map((id) => invited[id]).filter((id) => id !== undefined)
  },
)

export const selectFilteredPeopleInvitedToOrg = createSelector(
  [selectUniquePeopleListModels],
  (people) => people.filter(() => true),
)
